export default __webpack_public_path__ + "e97b03c89094a78dcd12c7a738f1484f.svg";